import { render, staticRenderFns } from "./ProfileForexCurrencyLimitsDeleteModal.vue?vue&type=template&id=041f813b"
import script from "./ProfileForexCurrencyLimitsDeleteModal.vue?vue&type=script&lang=js"
export * from "./ProfileForexCurrencyLimitsDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports